export enum LinkTextConfig {
  linkReplaceSymbol = '"[Link]"',
  newWindowModalSymbol = '_modal',
  newWindowSelfSymbol = '_self',
}
